import type { DescribeToolActivityOptions } from "./describe-tool-activity-options";
import type { ToolActivityState } from "./tool-activity-state";
import { softFailedBrowser } from "./browser/soft-failed-browser";
import { softFailedCapture } from "./capture/soft-failed-capture";
import { softFailedGit } from "./git/soft-failed-git";
// Capture, browser and git tools report some failures as prose on a `completed` call.
export function toolActivityStateFor(
  toolName: string,
  options: DescribeToolActivityOptions | undefined,
): ToolActivityState {
  const isRunning = options?.status === "running";
  return {
    isRunning,
    output: options?.output,
    hasFailed:
      options?.status === "failed" ||
      (!isRunning &&
        (softFailedCapture(toolName, options?.output) ||
          softFailedBrowser(toolName, options?.output) ||
          softFailedGit(toolName, options?.output))),
  };
}
